import { render, staticRenderFns } from "./HeartIcon.vue?vue&type=template&id=527b57c9&"
import script from "./HeartIcon.vue?vue&type=script&lang=ts&"
export * from "./HeartIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports